/** @deprecated search renderBigNumber */
export const numberChange = (
  value: number | undefined,
  fixed = 2,
  addComma = false,
  useReal = false
) => {
  if (value !== 0 && !value) {
    return "-";
  } else if (value < 1000) {
    return useReal ? value : "小于 0.1 万";
  } else if (value < 100000000) {
    return `${
      addComma
        ? (+(value / 10000).toFixed(fixed)).toLocaleString()
        : (value / 10000).toFixed(fixed)
    } 万`;
  } else {
    return `${
      addComma
        ? (+(value / 100000000).toFixed(fixed)).toLocaleString()
        : (value / 100000000).toFixed(fixed)
    } 亿`;
  }
};

// 人群规模显示规则文档 /doc/499256303507922944?root=494471587257016320
export const peopleSizeShow = (value: number | undefined) => {
  if (!value && value !== 0) {
    return "-";
  }

  const currentValue = value as number;
  const base = 10000;

  if (currentValue < base) {
    return "不足 1 万，不可创建人群";
  } else if (currentValue >= 5000 * base) {
    return "超过 5000 万，不可以创建人群，必须缩减至 5000 万以内";
  } else {
    const count = Math.floor(currentValue / base);
    let pow = 0,
      resultValue = count;
    // 找出指数
    while (resultValue >= 10) {
      pow += 1;
      resultValue = Math.floor(resultValue / 10);
    }
    return `${resultValue * Math.pow(10, pow)} 万 ～ ${
      (resultValue + 1) * Math.pow(10, pow)
    } 万`;
  }
};
